<template>
    <div id="printContainer">
      <!-- <div class="footer">我是页脚</div> -->
        <div style="width: 21cm;height: 29.7cm;" v-if="cover">
            <img :src="cover" style="width: 100%;height: 100%;">
        </div>
        <div style="page-break-before: always"></div>
        <div style="width: 21cm;height: 29.7cm;line-height: 34px;" v-if="preface" v-html="preface"></div>
        <div style="page-break-before: always"></div>
        <div v-for="item in questionList" :key="item._id.$id" style="margin-bottom:20px;line-height: 34px;page-break-inside: avoid;" :style="{fontFamily:font}">
            <div v-html="item.question_question" style="margin-bottom: 10px;"></div>
            <div style="display: flex;align-items: flex-start;">A. <div v-html="item.question_optionA"></div></div>
            <div style="display: flex;align-items: flex-start;">B. <div v-html="item.question_optionB"></div></div>
            <div style="display: flex;align-items: flex-start;" v-if="item.question_optionC">C. <div v-html="item.question_optionC"></div></div>
            <div style="display: flex;align-items: flex-start;" v-if="item.question_optionD">D. <div v-html="item.question_optionD"></div></div>
            <div style="display: flex;align-items: flex-start;" v-if="item.question_optionE">E. <div v-html="item.question_optionE"></div></div>
        </div>
    </div>
</template>

<script>
import { getExerciseTemplate } from '../api/examAdmin'
export default {
  data () {
    return {
      cover: '',
      preface: '',
      font: '',
      margin: '',
      questionList: []
    }
  },
  mounted () {
    getExerciseTemplate(this.$route.query.id).then(res => {
      if (res.data.code === 0) {
        this.cover = res.data.data.export_cover
        this.preface = res.data.data.preface
        this.font = res.data.data.font
        this.margin = res.data.data.margin
        const questionList = []
        for (const item of res.data.data.sections_item) {
          for (const item1 of item.questions_item) {
            questionList.push(item1)
          }
        }
        this.questionList = questionList

        setTimeout(() => {
          const dom = document.getElementById('printContainer')
          window.document.body.innerHTML = dom.innerHTML

          const style = document.createElement('style')
          style.innerHTML = `@media print { @page {size:21cm 29.7cm; margin: ${this.margin}px;}}`
          window.document.body.appendChild(style)
          window.print()
        }, 1000)
      }
    })
  }
}
</script>

<style lang="scss">
p{
  margin-top: 0;
  margin-bottom:0
}
// body{
//   counter-reset: page 1;
// }
// .footer{
//   display: none;
// }
// @media print {
//     .footer{
//       position:fixed;
//       bottom:0;
//       right: 0;
//       z-index:9999;
//       display: block!important;
//     }
//     @page {
//       size:  21cm 29.7cm;
//       margin: 50px;
//       counter-increment: page;
//     }
//     .footer::before{
//       content: counter(page)'. ';
//     }
//   }
// #printContainer{

// }
</style>
